import { makeApp } from './app'

const { app, store } = makeApp()

if (window.__INITIAL_STATE__) {
  store.state.value = window.__INITIAL_STATE__
}

app.mount('#tvb', true)
